export const LEXIS_NEXIS = 'lexisNexis';
export const LEGACY_ELECTIVE_PLACEHOLDER = 'legacyElectivePlaceHolder';